import { render, staticRenderFns } from "./UserContextMenu.vue?vue&type=template&id=093b09fa&scoped=true&"
import script from "./UserContextMenu.vue?vue&type=script&lang=js&"
export * from "./UserContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserContextMenu.vue?vue&type=style&index=0&id=093b09fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b09fa",
  null
  
)

export default component.exports